var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovalTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#1E2B45",
    fillOpacity: 0.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20L28.56 17.21L28.9 13.52L25.29 12.7L23.4 9.5L20 10.96L16.6 9.5L14.71 12.69L11.1 13.5L11.44 17.2L9 20L11.44 22.79L11.1 26.49L14.71 27.31L16.6 30.5L20 29.03L23.4 30.49L25.29 27.3L28.9 26.48L28.56 22.79L31 20ZM17.38 24.01L15 21.61C14.61 21.22 14.61 20.59 15 20.2L15.07 20.13C15.46 19.74 16.1 19.74 16.49 20.13L18.1 21.75L23.25 16.59C23.64 16.2 24.28 16.2 24.67 16.59L24.74 16.66C25.13 17.05 25.13 17.68 24.74 18.07L18.82 24.01C18.41 24.4 17.78 24.4 17.38 24.01Z",
    fill: "#F9FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalTransaction);
export default __webpack_public_path__ + "static/media/approvalTransaction.2b747309b4d8bd4fdc7093705020919a.svg";
export { ForwardRef as ReactComponent };